
  import { Record, Partial, Static, Number, String, Always, Intersect2, Constraint, Literal } from 'runtypes';

  export const ___baseEventTypeDefinition = Record({
  eventId: Literal(18),
  playerId: Number.withConstraint(x => x >= 1),
  hasBeenGuest: Number.withConstraint(x => x >= 0 && x <= 1),
  timezone: Number.withConstraint(x => x >= 0 && x <= 255),
  event_mapping_version: Literal(2),
}).And(Partial({
  distributorId: Number,
  partnerId: Number,
  creative: Number,
  accountHash: String,
  lp: Number,
  aid: Number,
  email: String,
  referrer: String,
  placement: String,
  keyword: String,
  googleNetwork: String,
  cid: String,
  tid: String,
  camp: Number,
  adgr: Number,
  matchtype: String.withConstraint(x => x.length <= 1),
  name: String,
}));
  export const ___completeEventTypeDefinition = Record({
  eventId: Literal(18),
  playerId: Number.withConstraint(x => x >= 1),
  hasBeenGuest: Number.withConstraint(x => x >= 0 && x <= 1),
  timezone: Number.withConstraint(x => x >= 0 && x <= 255),
  event_mapping_version: Literal(2),
  gameId: Number.withConstraint(x => x >= 1 && x <= 100),
  networkId: Number.withConstraint(x => x >= 1 && x <= 1000),
  instanceId: Number.withConstraint(x => x >= 1 && x <= 1000),
}).And(Partial({
  distributorId: Number,
  partnerId: Number,
  creative: Number,
  accountHash: String,
  lp: Number,
  aid: Number,
  email: String,
  referrer: String,
  placement: String,
  keyword: String,
  googleNetwork: String,
  cid: String,
  tid: String,
  camp: Number,
  adgr: Number,
  matchtype: String.withConstraint(x => x.length <= 1),
  name: String,
  zoneId: Number,
  lang: String,
}));

  export type Event = Static<typeof ___baseEventTypeDefinition>;

  /** The event type with the shared values added */
  export type EventWithCommonParameters = Static<typeof ___completeEventTypeDefinition>;

  export const validateEvent = (o: any) => ___completeEventTypeDefinition.validate(o);

  export const ID = 18;
  